import { post } from "../client";
import apiEndpoints from "../endpoints";

export interface LoginRequest {
  email: string;
}

export interface RegisterRequest {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
}

export interface VerifyOtpRequest {
  otp: string;
  email: string;
}

export interface UpdateFCMTokenRequest {
  token: string;
}

export interface AuthResponse {
  details: string;
  token: {
    access: string;
    refresh: string;
  };
  user_info: {
    id: number;
    name: string;
    phone: string;
    email: string;
    profile_types: { id: number; profile_type: number }[];
  };
}

export const authApi = {
  login: (email: string) => post(apiEndpoints.auth.login, { email }),

  register: (data: RegisterRequest) => post(apiEndpoints.auth.register, data),

  verifyOtp: (data: VerifyOtpRequest) =>
    post<AuthResponse>(apiEndpoints.auth.verifyOtp, data),

  refreshToken: (refreshToken: string) =>
    post(apiEndpoints.auth.refresh, { refresh: refreshToken }),

  updateFCMToken: (data: UpdateFCMTokenRequest) =>
    post(apiEndpoints.auth.updateFCMToken, data),
};

export default authApi;
